// extracted by mini-css-extract-plugin
module.exports = {"UiAvatar":"avatar_UiAvatar__JRROe"};